import React from "react";
import { Button, ProgressBar } from "../ui";
import { Clock, Play, Sessions } from "../icons";
import HeroPattern from "./HeroPattern";
import { TYPE_LABEL, itemPercent, openLabel } from "../../lib/learning";

/**
 * "Continue where you left off" — the single most useful thing on the page, so
 * it gets the only gradient surface in the product.
 *
 * The item is chosen by `pickResumeItem` from the learner's real plan; when
 * there is nothing open the panel says so plainly instead of manufacturing a
 * call to action. The two activity figures ride along in the same panel because
 * they answer "how am I doing" at the same glance, and neither deserves a card
 * of its own.
 */
export const ContinueCard = ({ item, activeTime, loginCount, onResume }) => {
  const pct = itemPercent(item);

  return (
    <section className="ds-hero">
      <HeroPattern />

      <div className="ds-hero__main">
        <p className="ds-hero__eyebrow">
          {item ? "Continue where you left off" : "Your learning"}
        </p>

        {item ? (
          <>
            <h1 className="ds-hero__title">
              {item.title}
              <span className="ds-hero__chip">
                {TYPE_LABEL[item.contentType] || item.contentType}
              </span>
            </h1>
            <p className="ds-hero__note">
              {pct > 0
                ? `You're ${pct}% through. Pick up where you stopped.`
                : "You haven't started this yet — it takes a few minutes to begin."}
            </p>

            <div className="ds-hero__progress">
              <ProgressBar value={pct} onBrand />
              <span className="ds-hero__pct">{pct}% complete</span>
            </div>

            <div style={{ marginTop: "auto" }}>
              <Button variant="onbrand" icon={Play} onClick={() => onResume(item)}>
                {openLabel(item.status)}
              </Button>
            </div>
          </>
        ) : (
          <>
            <h1 className="ds-hero__title">Nothing open right now</h1>
            <p className="ds-hero__note">
              You've finished everything assigned to you. Browse the sections
              below to keep going, or try a warm up.
            </p>
          </>
        )}
      </div>

      <div className="ds-hero__stats">
        <div className="ds-hero__stat">
          <Clock size={17} style={{ opacity: 0.7 }} />
          <span className="ds-hero__stat-value">{activeTime || "—"}</span>
          <span className="ds-hero__stat-label">Active screen time</span>
        </div>
        <div className="ds-hero__stat">
          <Sessions size={17} style={{ opacity: 0.7 }} />
          <span className="ds-hero__stat-value">{loginCount ?? 0}</span>
          <span className="ds-hero__stat-label">Total logins</span>
        </div>
      </div>
    </section>
  );
};

export default ContinueCard;
